module.exports = __webpack_public_path__ + "img/icon23.d7fdd5cf.png";